import {
  Button,
  Container,
  createStyles,
  Dialog,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Slide,
  TextField,
  Theme,
  Typography,
  withStyles
} from "@material-ui/core";
import CustomCheckBox from "../../../creator/experienceManager/participantsDashboard/component/CustomCheckbox";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import {DialogTitleProps} from "../../../creator/experienceManager/participantsDashboard";
import CloseIcon from '@material-ui/icons/Close';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React, {useEffect, useState} from "react";
import {TransitionProps} from "@material-ui/core/transitions";
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions/DialogActions";
import {
  addNewParticipantTag,
  deleteParticipantTag,
  getAllTagsByTypes,
  updateParticipantTag
} from "../../../../../store/actions/creator/creatorExperienceManager";
import UtilService from "../../../../../helper/service";
import {useDispatch, useSelector} from "react-redux";
import ImmersionModal from "../../../../atoms/modals/commonModal";
import {getListParticipants, initListDetailData, onUpdateTags} from "../../../../../store/actions/participant/list";
import CustomSnackBar from "../../../creator/experienceManager/participantsDashboard/component/CustomSnackBar";
import { Loading } from "../../../../atoms/commonLoadings";

const useStyles = makeStyles((theme) => ({
  tagModalWrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  tagModalContent: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    fontFamily: 'roboto-regular',
  },
  tagModalList: {
    border: "1px solid #B2B9C0",
    borderRadius: 6,
    padding: theme.spacing(1),
    height: 250,
    overflowY: 'scroll'
  },
  tagModalListItem: {
    paddingLeft: 0,
    paddingRight: 0
  },
  tagModalCheckbox: {
    padding: 0,
    margin: 0,
    minWidth: 35,
    textAlign: 'left'
  },
  tagModalCheckTitle: {
    color: '#697683',
    fontSize: 14,
    letterSpacing: -15
  },
  tagModalAddForm: {
    marginTop: theme.spacing(1),
    width: '100%',
    minWidth: 37,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  tagModalAddInput: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    flex: 1,
    height: '100%',
    padding: 0,
    marginRight: theme.spacing(1),
    borderRadius: 6
  },
  tagModalAddBtn: {
    minWidth: 37,
    height: 37,
    borderRadius: 6,
    backgroundColor: '#E5E5E5',
    boxShadow: 'none',
    padding: 0
  },
  tagModalAddBtnTxt: {
    fontFamily: 'roboto-regular',
    fontSize: 24,
    color: '#697683'
  },
  tagModalAction: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  tagModalActionBtn: {
    borderRadius: 6,
    width: 91,
    height: 37,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    color: '#FFFFFF',
    textTransform: 'none',
    background: '#0179EE',
    '&:hover': {
      background: '#0f9fef'
    }
  },
}));

const styles = (theme: Theme) =>
  createStyles({
    tagmodalheader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      color: theme.palette.grey[500],
      fontFamily: 'roboto-bold',
    },
    closeBtnIcon: {
      color: '#212D4080',
      width: 24,
      height: 24,
      fontFamily: 'roboto-bold'
    },
    modaltitle: {
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'left'
    }
  });

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.tagmodalheader} {...other}>
      <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon classes={{ root: classes.closeBtnIcon }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

interface IProps {
  listId: string;
  open: boolean;
  onClose: () => void;
  isAdding: boolean;
  selectedParticipant: any;
  selectedParticipants: any[];
  onClearSelected: () => void;
}

const ParticipantTagModal = (props: IProps) => {
  const classes = useStyles();
  const { open, listId, isAdding, selectedParticipant, selectedParticipants, onClose, onClearSelected } = props;
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const [isLoadingTags, setLoadingTags] = useState(false);
  const [newTagName, setNewTagName] = useState('');
  const [showSelectedTags, setShowSelectedTags] = useState([]);
  const [checked, setChecked] = useState([0]);
  const [allTags, setAllTags] = useState<any[]>([]);
  const [editTag, setEditTag] = useState(false);
  const [isAllowApply, setIsAllowApply] = useState(false);
  const [deleteTag, setDeleteTag] = useState('');
  const [isAddTagError, setAddTagError] = useState(false);
  const [loadingAddTag, setLoadingAddTag] = useState(false);
  const [isShownUpdateTagLoading, setShownUpdateTagLoading] = useState(false);

  const [snackAlertType, setSnackAlertType] = useState('');
  const [snackAlertMsg, setSnackMsg] = useState('');
  const [isShowSnackAlert, setIsShowSnackAlert] = useState(false);

  useEffect(() => {
    if (open) {
      setIsShowSnackAlert(false);
      getAllParticipantsTags(true);
    }
  }, [open]);

  useEffect(() => {
    const tagData: any = editTag;
    if (tagData.tagName) {
      setNewTagName(tagData.tagName);
    }
  }, [editTag]);

  const onCloseModal = () => {
    setNewTagName('');
    setLoadingAddTag(false);
    setChecked([0]);
    setIsAllowApply(false);
    setAddTagError(false);
    setShownUpdateTagLoading(false);
    setEditTag(false);
    setLoadingTags(false);
    setDeleteTag('');
    setShowSelectedTags([]);
    setAllTags([]);
    setIsShowSnackAlert(false);
    onClose();
  };

  const getAllParticipantsTags = async (updateChecked: boolean) => {
    try {
      setLoadingTags(true);
      const request: any = {
        type: 1,
        department_id: loginUserData.department_id
      };
      const tagsRes = await getAllTagsByTypes(apolloClient.client, request);
      let allTagList = [];
      const checkedArr: any[] = [];
      if (tagsRes.data.viewTagsByTypes) allTagList = tagsRes.data.viewTagsByTypes;

      let extTagArray: string[] = [];
      if (selectedParticipant && selectedParticipant.tags && selectedParticipant.tags.length > 0) {
        const tagNames = UtilService.getParsedTagArray(selectedParticipant.tags);
        extTagArray = extTagArray.concat(tagNames);
	  } else {
		  if (selectedParticipants.length === 1|| !isAdding) {
			  selectedParticipants.forEach((p: any) => {
				  if (p.tags && p.tags.length > 0) {
					  const tagNames = UtilService.getParsedTagArray(p.tags);
					  extTagArray = extTagArray.concat(tagNames);
				  }
			  });
		  }
	  }
      allTagList.forEach((t: any) => {
        if (extTagArray.indexOf(t.tagName) !== -1) checkedArr.push(t.tagId);
        if (newTagName && newTagName === t.tagName && !checkedArr.includes(t.tagId)) {
          checkedArr.push(t.tagId)
        }
        if (showSelectedTags.length > 0) {
          showSelectedTags.map((value: any) => {
            if (value.toLowerCase() === t.tagName.toLowerCase()) {
              checkedArr.push(t.tagId)
            }
          })
        }
      });
      if (updateChecked) setChecked(checkedArr);
      setAllTags(allTagList);
      setLoadingTags(false);
    } catch (error) {
      showSnackAlert('Getting Failed! Please try again later!', 'error');
    }
  };

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    //remove duplicate from array
    const filtered = newChecked.filter((a, b) => newChecked.indexOf(a) === b);
    setChecked(filtered);
    setIsAllowApply(true)
  };

  const onChangeTagName = (e: any) => {
    e.preventDefault();
    const value = e.target.value;
    setNewTagName(value);
    setAddTagError(value.length === 0)
  };

  const handleEditTagsParticipants = async () => {
    if (selectedParticipant) { // if participant is selected using dot left menu (edit tags)
      const participantList = [];
      participantList.push(selectedParticipant);
      await onEditTags([...participantList])
    } else { // if participants are selected using checkbox
      if (selectedParticipants.length === 0) {
        return onCloseModal();
      }
      await onEditTags(selectedParticipants);
    }
  };

  const onEditTags = async (participantList: any) => {
    setShownUpdateTagLoading(true);
    let selTags: any[] = [];
    let tags: any[] = [];

    if (checked.length) {
      if (checked[0] === Number(0)) checked.shift();
      selTags = allTags.filter(t => checked.indexOf(t.tagId) !== -1);
    }

    if (selTags.length) {
      const selTagNameArr = selTags.map((t) => Object.assign({}, { tag_name: t.tagName }));
      tags = [...selTagNameArr];
    }
    const participants = participantList.map((p: any) => {
      let newTags = [];
      const currentTags = p.tags;
      if (currentTags && currentTags.length > 0) {
        if (isAdding) {
          const uniqTags = tags.filter((t: any) => {
            for (let i = 0; i < currentTags.length; i++) {
              if (t.tag_name === currentTags[i].tag_name) {
                return;
              }
            }
            return t;
          });
          newTags = currentTags.concat(uniqTags);
        } else {
          newTags = currentTags.filter((ct: any) => {
            for (let i = 0; i < tags.length; i ++) {
              if (ct.tag_name === tags[i].tag_name) {
                return ct;
              }
            }
          });
        }
      } else {
        newTags = isAdding ? [...tags] : [];
      }
      return {
        email: p.email,
        tags: newTags
      }
    });

    const request = {
      participants
    };
    dispatch(onUpdateTags(apolloClient.client, request, (res: any) => {
      if (res) {
        dispatch(initListDetailData());
        setTimeout(() => {
          const req = {
            page: 0,
            group_id: Number(listId)
          };
          dispatch(getListParticipants(apolloClient.client, req, false));
        }, 1000);
      }
    }));
    onClearSelected();
    onCloseModal();
  };

  const handleDeleteTag = async () => {
    const tagId = deleteTag;
    const user_id = loginUserData.user_id;
    setDeleteTag('');
    try {
      setLoadingTags(true);
      const deleteTagResult = await deleteParticipantTag(apolloClient.client, parseInt(tagId), user_id);
      if (deleteTagResult.data.deleteTag.status === true) {
        const resData = deleteTagResult.data.deleteTag;
        showSnackAlert(resData.message, 'success');
        getAllParticipantsTags(false);
        setChecked(checked.filter((item: any) => item.tagId !== tagId));
      } else {
        showSnackAlert(deleteTagResult.data.deleteTag.message, 'error');
      }
    } catch (error) {
      showSnackAlert(JSON.stringify(error), 'error');
    }
    setLoadingTags(false);
  };

  const showSnackAlert = (msg: string, type: string) => {
    setSnackMsg(msg);
    setSnackAlertType(type);
    setIsShowSnackAlert(true);
  };

  const hideSnackAlert = () => {
    setIsShowSnackAlert(false);
  };

  const handleAddTagSubmit = async (e: any) => {
    e.preventDefault();
    if (!newTagName || newTagName.trim().length === 0 || newTagName.trim() === '-') {
      setAddTagError(true);
      return;
    }
    try {
      setLoadingAddTag(true);
      const alreadyExistsTag = allTags.filter(function (tag) {
        if (tag.tagName.toLowerCase() === newTagName.toLowerCase()) {
          return tag;
        }
      });
      if (alreadyExistsTag.length > 0) {
        setChecked([...checked, alreadyExistsTag[0].tagId]);
        showSnackAlert("Tag already existed and selected.", 'error');
        setLoadingAddTag(false);
        setNewTagName('');
        setEditTag(false);
        return false
      }
      if (editTag) {
        const tagData: any = editTag;
        const request: any = {
          tagName: newTagName,
          tagDescription: tagData.tagDescription ? tagData.tagDescription : "",
          tagId: parseFloat(tagData.tagId),
          user_id: parseFloat(loginUserData.user_id),
          department_id: loginUserData.department_id,
        };
        const updateTagResult = await updateParticipantTag(apolloClient.client, request);
        if (updateTagResult.data.updateTag.status === true) {
          const resData = updateTagResult.data.updateTag;
          showSnackAlert(resData.message, 'success');
          setEditTag(false);
          getAllParticipantsTags(false);
        } else {
          showSnackAlert(updateTagResult.data.updateTag.message, 'error');
        }
      } else {
        const addTagResult = await addNewParticipantTag(loginUserData.department_id, newTagName, parseFloat(loginUserData.user_id), apolloClient.client);
        if (addTagResult.data.addTag.status === true) {
          const resData = addTagResult.data.addTag;
          showSnackAlert(resData.message, 'success');
          getAllParticipantsTags(false);
          setChecked([...checked, addTagResult.data.addTag.data.tagId]);
        } else {
          showSnackAlert(addTagResult.data.addTag.message, 'error');
        }
      }
    } catch (error) {
      showSnackAlert(JSON.stringify(error), 'error');
    }
    setNewTagName('');
    setLoadingAddTag(false);
    setIsAllowApply(true);
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        classes={{
          paper: classes.tagModalWrap
        }}
        onClose={onCloseModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" onClose={onCloseModal}>{`${isAdding ? 'Add' : 'Remove'} Participant Tags`}</DialogTitle>
        <DialogContent dividers>
          <Container maxWidth="md">
            <div className={classes.tagModalContent}>
              {isLoadingTags && (
                  <Loading style={{ width: 70, height: 70, margin: 'auto' }}/>
              )}
              {!isLoadingTags && (
                <div>
                  {!allTags.length && (
                    <div>No available tags, please add new tags</div>
                  )}
                  {allTags.length > 0 && (
                    <List className={classes.tagModalList}>
                      {
                        allTags.map((value: any) => {
                          const labelId = `checkbox-list-label-${value.tagId}`;
                          return (
                            <ListItem key={value.tagId} role={undefined} dense button className={classes.tagModalListItem} onClick={handleToggle(value.tagId)}>
                              <ListItemIcon>
                                <CustomCheckBox
                                  edge="start"
                                  color="primary"
                                  checked={checked.indexOf(value.tagId) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  className={classes.tagModalCheckbox}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText className={classes.tagModalCheckTitle} id={labelId} primary={value.tagName} />
                              <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="edit" onClick={() => { setEditTag(value) }}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton edge="end" aria-label="edit" onClick={() => { setDeleteTag(value.tagId) }}>
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                          );
                        })
                      }
                    </List>
                  )}
                </div>
              )}
            </div>
            <form className={classes.tagModalAddForm} onSubmit={handleAddTagSubmit} noValidate autoComplete="off">
              <TextField
                error={isAddTagError}
                helperText={isAddTagError ? 'Tag name is required.' : ''}
                variant="outlined"
                size="small"
                required
                disabled={isLoadingTags}
                placeholder={!editTag ? "Add a new Tag ..." : "Update Tag..."}
                InputProps={{ className: classes.tagModalAddInput }}
                classes={{
                  root: classes.tagModalAddInput
                }}
                name="participant_tag"
                value={newTagName}
                onChange={onChangeTagName}
              />
              {isLoadingTags && (
                <Button
                  variant="contained"
                  disabled
                  className={classes.tagModalAddBtn}
                >
                  <AddSharpIcon className={classes.tagModalAddBtnTxt} />
                </Button>
              )}
              {!isLoadingTags && (
                <Button
                  variant="contained"
                  type="submit"
                  disabled={loadingAddTag}
                  className={classes.tagModalAddBtn}
                >
                  {loadingAddTag && <Loading style={{ width: 37, height: 37 }}/>}
                  {!loadingAddTag && (!editTag ? <AddSharpIcon className={classes.tagModalAddBtnTxt} /> : <DoneIcon className={classes.tagModalAddBtnTxt} />)}
                </Button>
              )}
              {editTag &&
                <>
                  &nbsp;
                  <Button
                    variant="contained"
                    type="button"
                    className={classes.tagModalAddBtn}
                    onClick={() => { setEditTag(false); setNewTagName('') }}
                  >
                    <CloseIcon className={classes.tagModalAddBtnTxt} />
                  </Button>
                </>
              }
            </form>
          </Container>
        </DialogContent>
        <DialogActions>
          <Container maxWidth="md" className={classes.tagModalAction}>
            {!isShownUpdateTagLoading && (
              <Button
                onClick={handleEditTagsParticipants}
                disabled={isLoadingTags || allTags.length === 0 || !isAllowApply}
                className={classes.tagModalActionBtn}
                style={(isLoadingTags || allTags.length === 0 || !isAllowApply) ? {backgroundColor: "#F0F0F0"} : {}}
              >
                Apply
              </Button>
            )}
            {isShownUpdateTagLoading && <Button variant="contained" color="primary" className={classes.tagModalActionBtn}>
              <Loading style={{ width: 37, height: 37 }}/>
            </Button>}
          </Container>
        </DialogActions>
      </Dialog>
      <ImmersionModal
        title={'Are you sure?'}
        description={'Do you really want to delete this tag?'}
        titleOK={'Yes'}
        open={!!deleteTag}
        onApply={handleDeleteTag}
        onClose={() => setDeleteTag('')}
      />
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShowSnackAlert} onClose={hideSnackAlert} />
    </>
  )
};

export default ParticipantTagModal;